import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApi } from '@backstage/core-plugin-api';
import { customAlertApiRef } from '@agilelab/plugin-wb-platform';
import { QUERY_KEY_ACCESS_TOKENS } from '../constants';
import { accessTokenApiRef } from '../plugin';
import { RemoveAccessTokenRequest } from '@agilelab/plugin-wb-service-accounts-common';
import { identityApiRef } from '@backstage/core-plugin-api';

interface DeleteAccessTokenRequest {
  uuid: string;
}

export const useDeleteAccessToken = (options?: { alertOnError?: boolean }) => {
  const queryClient = useQueryClient();
  const alertApi = useApi(customAlertApiRef);
  const accessTokenApi = useApi(accessTokenApiRef);
  const identityApi = useApi(identityApiRef);

  const removeAccessToken = async (request: DeleteAccessTokenRequest) => {
    const identityRef = await identityApi.getBackstageIdentity();
    const userEntityRef = identityRef.userEntityRef;

    const apiRequest: RemoveAccessTokenRequest = {
      uuid: request.uuid,
      askedBy: userEntityRef,
    };

    return accessTokenApi.removeAccessToken(apiRequest);
  };

  const defaultOnSuccess = () => {
    queryClient.invalidateQueries({
      queryKey: [QUERY_KEY_ACCESS_TOKENS],
    });
  };

  return useMutation<void, Error, DeleteAccessTokenRequest>({
    mutationFn: removeAccessToken,
    onSuccess: defaultOnSuccess,
    onError: (error: Error) => {
      if (options?.alertOnError === false) return;
      alertApi.post({
        severity: 'error',
        message: error.message || 'Failed to delete access token',
      });
    },
  });
};
